module.exports = __webpack_public_path__ + "static/media/error-404.8f2402c9.svg";